import {copilot} from '@cl/shared';
import accountAnalyticsAgent from 'common/src/modules/analytics/copilot/agents/accountAnalyticsAgent/accountAnalyticsAgent';
import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';
import {CLStore} from 'common/src/redux/store';

function initializeAnalyticsAgents(store: CLStore) {
  if (isFlagEnabled(FeatureFlagKey.EnableCopilotAccountAnalyticsAgent)) {
    copilot.registerAgent(accountAnalyticsAgent(store));
  }
}

export default initializeAnalyticsAgents;
